import classNames from "classnames";
import * as React from "react";

import * as styles from "./styles.css";

export interface IProps extends styles.Sprinkles {
  /** Class name applied to the svg tag */
  className?: string;
  /** data-test-id applied to the svg tag */
  "data-test-id"?: string;
  /**
   * Aria label for the skeleton loader
   */
  ariaLabel?: string;
}

/**
 * @trackcomponent
 */
export const LoadingSkeletonBase: React.FC<IProps> = ({
  className,
  ["data-test-id"]: dataTestId,
  ariaLabel,
  ...props
}) => {
  const { className: sprinklesClassName, style } =
    styles.rainbowSprinkles(props);
  return (
    <div
      role="status"
      aria-label={ariaLabel}
      data-test-id={dataTestId}
      style={style}
      className={classNames(className, styles.container, sprinklesClassName)}
    >
      <div
        className={classNames(
          className,
          styles.staticBackground,
          sprinklesClassName
        )}
      >
        <div
          className={classNames(
            className,
            styles.animatedBackground,
            sprinklesClassName
          )}
        />
      </div>
    </div>
  );
};
